import { errorDev } from './logger';
const CONTROL_CHARS = /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g;
const TAGS = /<[^>]*>/g;

export function sanitizeText(value, maxLength = 2000) {
  if (value == null) return "";
  const text = String(value)
    .replace(CONTROL_CHARS, "")
    .replace(TAGS, "")
    .replace(/\s+/g, " ")
    .trim();

  if (maxLength > 0 && text.length > maxLength) {
    return text.slice(0, maxLength);
  }
  return text;
}

export function sanitizeEmail(value) {
  const email = sanitizeText(value, 254).toLowerCase();
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ? email : "";
}

export function sanitizeId(value) {
  return sanitizeText(value, 120).replace(/[^a-zA-Z0-9._-]/g, "");
}

export function sanitizeUrl(value) {
  const raw = sanitizeText(value, 1024);
  if (!raw) return "";
  try {
    const parsed = new URL(raw, window.location.origin);
    if (parsed.protocol === "http:" || parsed.protocol === "https:") {
      return parsed.toString();
    }
    return "";
  } catch (err) {
    errorDev("Operation failed:", err);
    return "";
  }
}
